<template>
  <div class="content apply">
    <van-row>
      <van-col class="slices">
        <img src="../assets/images/slices1.png">
        <div class="apply1" id="apply1">
          <div style="font-size: .32rem;text-align: center;padding-top: .6rem;">价值<font color="#FC8CD6" style="font-size: .36rem;">1469</font>元的电销神器只需<font color="#FC8CD6" style="font-size: .36rem;">99</font>元即可试用</div>
          <van-row style="width: 5.4rem;margin: auto;padding: .6rem 0;">
            <van-col :span="24">
              <input type="text" name="" v-model="param.trialOrganizationName" placeholder="机构名称">
            </van-col>
            <van-col :span="24">
              <input type="text" name="" v-model="param.trialName" placeholder="姓名">
            </van-col>
            <van-col :span="24">
              <input type="text" name="" v-model="param.trialPhone" placeholder="请输入手机号">
            </van-col>
            <van-col :span="14">
              <input type="text" name="" v-model="param.code" placeholder="请输入手机验证码">
            </van-col>
            <van-col :span="1"></van-col>
            <van-col :span="9">
              <!-- <button>获取验证码</button> -->
              <button type="" :disabled="codeDisabled" @click="getCode" v-text="codeText" :class="codeDisabled?'disabled':''"></button>
            </van-col>
            <van-col :span="24" v-if="captchaObj" style="border-color: transparent;border-radius: 0;">
              <div id="captcha"></div>
            </van-col>
            <van-col :span="24" style="margin-top: .35rem;">
              <button @click="submit">立即申请试用</button>
            </van-col>
          </van-row>
        </div>
      </van-col>
      <van-col class="slices">
        <img src="../assets/images/slices2.png">
      </van-col>
      <van-col class="slices">
        <img src="../assets/images/slices3.png">
      </van-col>
      <van-col class="slices">
        <img src="../assets/images/slices4.png">
      </van-col>
      <van-col class="slices">
        <img src="../assets/images/slices5.png">
      </van-col>
      <van-col class="slices">
        <img src="../assets/images/slices6.png">
        <van-row style="width: 5.4rem;position: absolute;top: 5.37rem;left: 1.05rem;">
          <van-col :span="24">
            <a href="#apply1" class="button">立即申请试用</a>
          </van-col>
        </van-row>
        <a href="#apply1" style="position: absolute;top: 18.8rem;left: 1.75rem;display: block;background-color: #fff;width: 4rem;height: .8rem;line-height: .8rem;text-align: center;font-size: .38rem;color: #659CFF;border:none;border-radius: .4rem;">立即申请试用</a>
      </van-col>
    </van-row>
  </div>
</template>
<script>
// import {} from '../../api';
import { getMsgCode, getGeetParm, submitTrial } from '../api';
export default {
  name: 'apply',
  data() {
    return {
      param: {
        inviterName: "",
        inviterOpenId: "",
        trialName: "",
        trialOpenId: "",
        trialOrganizationName: "",
        trialPhone: "",
        code: ""
      },
      t: "",
      countdown: 60,
      codeText: "获取验证码",
      codeDisabled: false,
      geetParm: {},
      captchaObj: "",
      needVerificationCode: 0,
      code: ""
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return "";
    },
    getCode() {
      var that = this;
      if (this.param.trialPhone == null || this.param.trialPhone == "") {
        this.$toast("请输入联系方式!")
        return;
      }
      getMsgCode("?tel=" + this.param.trialPhone + "&&needVerificationCode=" + that.needVerificationCode + "&&type=2").then(res => {
        if (res.code == 1) {
          that.$toast("验证码发送成功!");
          that.code = res.data.code;
          that.t = window.setInterval(function () {
            that.countdown--;
            if (that.countdown == 0) {
              window.clearInterval(that.t);
              that.codeText = "获取验证码";
              that.countdown = 60;
              that.codeDisabled = false;
            } else {
              that.codeText = that.countdown + "后可重发";
              that.codeDisabled = true;
            }
          }, 1000);
        } else {
          that.$toast(res.message);
          if (res.data == 0) {
            that.initGeet();
          }
        }
      })
    },
    initGeet() {
      var _this = this;
      if (_this.captchaObj) {
        _this.needVerificationCode = 0;
        _this.captchaObj.reset();
      } else {
        getGeetParm("?client_type=web").then(res => {
          if (res.code == 1) {
            initGeetest({
              // 以下配置参数来自服务端 SDK
              gt: res.data.gt,
              challenge: res.data.challenge,
              offline: !res.data.success,
              new_captcha: true,
              product: 'popup',
              width: "100%"
            }, function (captchaObj) {
              // 这里可以调用验证实例 captchaObj 的实例方法
              _this.captchaObj = captchaObj;
              _this.captchaCallback(_this);
            })
          } else {
            _this.$toast(res.message);
          }
        })
      }
    },
    captchaCallback(_this) {
      _this.captchaObj.appendTo("#captcha"); //将验证按钮插入到宿主页面中captchaBox元素内
      _this.captchaObj.onReady(function () {
        //your code
      }).onSuccess(function () {
        //your code
        console.log("success")
        _this.needVerificationCode = 1;
      }).onError(function () {
        //your code
        console.log("error")
      })
    },
    submit() {
      var that = this;
      if (this.param.trialOrganizationName == "") { this.$toast("请输入机构名称！"); return; }
      if (this.param.trialName == "") { this.$toast("请输入联系人姓名！"); return; }
      if (this.param.trialPhone == "") { this.$toast("请输入联系方式！"); return; }
      if (this.param.code == "") { this.$toast("请输入验证码！"); return; }
      if (this.param.code != this.code) { this.$toast("验证码输入错误！"); return; }
      submitTrial(this.param).then(function (res) {
        if (res.code == 1) {
          that.$toast("申请成功，我们将尽快联系您！")
        } else {
          that.$toast(res.message);
        }
      })
    }
  },
  mounted() {
    if (location.href.indexOf("yunkeweidian") > -1) {
      location.href = "http://www.yunkeweidian.com";
    } else if (location.href.indexOf("yiliangkeji") > -1) {
      location.href = "https://www.yiliangkeji.cn";
    }
    this.param.inviterName = this.getQueryString("nickname");
    this.param.inviterOpenId = this.getQueryString("openid");
    this.param.trialOpenId = sessionStorage.getItem('openId');
  }
}
</script>
<style type="text/css">
.apply .slices {
  position: relative;
}
.apply .slices img {
  width: 100%;
  display: block;
  padding: 0;
  margin: 0;
  border: none;
}
.apply1 {
  width: 7rem;
  height: 7.4rem;
  background-color: #fff;
  box-shadow: 0 0.1rem 0.5rem 0 rgba(37, 147, 125, 0.5);
  border-radius: 0.2rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0.25rem;
}
.apply input {
  width: 100%;
  height: 0.86rem;
  line-height: 0.86rem;
  font-size: 0.28rem;
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  border-width: 0;
  padding-left: 0.3rem;
  margin-bottom: 0.15rem;
  border-radius: 9px;
}
.apply button,
.apply .button {
  width: 100%;
  background-color: #649bff;
  height: 0.86rem;
  line-height: 0.86rem;
  border-radius: 0.1rem;
  text-align: center;
  color: #fff;
  font-size: 0.28rem;
  border-color: #649bff;
  border-width: 0;
  display: inline-block;
}
.apply button.disabled {
  background-color: #dedede;
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/views/apply/index.vue



// WEBPACK FOOTER //
// src/views/index.vue